import { VueLogger } from 'vue-logger-plugin';
import VueCookies from 'vue-cookies';
import axios from 'axios';

const loggerUrl = 'https://api.preludeadv.it/api/v1/out_v1/log_errore.asp';
// after hook to send log messages to api endpoint
const ServerLogHook = {
    run: (event) => {
        const dataObj = event.argumentArray[0],
            params = new URLSearchParams();
        const postData = {
            'chi': 'riv',
            'token': VueCookies.get('seller').biscotti,
            'messaggio': '[' + event.level.toUpperCase() + '] ' +  Object.values(dataObj).join(' - ')
        }


        Object.entries(postData).forEach(([key, value]) => {
            params.append(key, value);
        });
         axios.post(loggerUrl, params).then(r => {
        }, r => {
           
        });
    }
}

// define options
const options = {
    enabled: true,
    level: 'debug',
    afterHooks: [ServerLogHook]
}

// export logger with applied options
export default new VueLogger(options)